module.exports = __webpack_public_path__ + "img/logomain.944b5b86.png";